import SimplePagination from '@/components/Pagination'export default SimplePagination